// extracted by mini-css-extract-plugin
export default {"term":"KQKXQCYl","tokenIcon":"hrsxYQfo"};